import TimesIcon from "@/assets/colorable/times_bold.svg?react";
import clsxm from "@/lib/clsxm";
import type {FC, MouseEvent, ReactNode} from "react";

const FilterChip: FC<{
  className?: string;
  count?: number;
  label: string | ReactNode;
  onRemove?: (e: MouseEvent<HTMLButtonElement>) => void;
  style?: "danger" | "default";
}> = ({className, count, label, onRemove, style = "default"}) => (
  <div
    className={clsxm(
      "text-primary-dark-solid bg-primary-light-solid flex min-h-8 items-center gap-2 rounded-md px-2.5 py-1",
      style === "danger" && "text-danger-medium-red bg-danger-light-red",
      className,
    )}>
    {typeof label === "string" ? <span className="line-clamp-1 text-sm font-semibold">{label}</span> : label}
    {count && (
      <span
        className={
          "text-primary-dark-solid flex min-h-5 min-w-5 items-center justify-center rounded-full bg-white p-1 text-sm leading-0 font-semibold"
        }>
        {count}
      </span>
    )}
    {onRemove && (
      <button onClick={onRemove}>
        <TimesIcon className="size-2 shrink-0" />
      </button>
    )}
  </div>
);

export default FilterChip;
